import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const WelcomeDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog onClose={handleClose} open={open}>
      {/* <IconButton
        sx={{ position: "absolute", top: "5px", right: "5px" }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton> */}

      <DialogContent>
        <img src={allImages.welcomeImage} alt="welcome-image" width={"100%"} />
        <Typography
          variant="h1"
          fontWeight={600}
          fontSize={"1.3rem"}
          fontFamily={"inter"}
          textAlign={"center"}
          mt={2}
        >
          Welcome to your LOBA
        </Typography>
        <Typography mt={1} variant="body2" textAlign={"center"}>
          Happy to have you onboard!
        </Typography>
        <Typography variant="body2" textAlign={"center"}>
          Here’s some tips to get you started
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <GlobalButton
          btnText={"Start"}
          styleProps={{ width: 140, height: 40 }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default WelcomeDialog;
